export const rootRoutes = {
  home: '/home',
  login: '/login',
  logout: '/logout',
  changePassword: '/change-password',
  requestResetPassword: '/request-reset-password',
  resetPassword: '/reset-password/:login/:hash',
  firstTimeLogin: '/login/:email/:hash',
  extAuthenticateSuccess: '/login/ext-authenticate-success',
  googleExtAuthenticateSuccess: '/login/google-ext-authenticate-success',
  disabledAccount: '/disabled-account',
  privacyPolicy: '/privacy-policy',
  changeExpiredPassword: '/change-expired-password'
};

export const settingsRoutes = {
  index: '/settings',
  profile: '/settings/profile',
  security: '/settings/security'
};

export const usersRoutes = {
  index: '/users',
  internal: '/users/internal',
  internalCreate: '/users/internal/create',
  internalUpdate: (login = ':login') => `/users/internal/${login}`,
  external: '/users/external',
  externalCreate: '/users/external/create',
  externalUpdate: (login = ':login') => `/users/external/${login}`
};

export const accessRoutes = {
  index: '/access',
  roles: '/access/roles',
  roleCreate: '/access/roles/new',
  roleEdit: (id = ':id') => `/access/roles/${id}`,
  roleCopy: (id = ':id') => `/access/roles/copy/${id}`
};

export const bulkOperationsRoutes = {
  index: '/bulk-operations',
  assignRoles: '/bulk-operations/assign-roles',
  removeRoles: '/bulk-operations/remove-roles'
};
